import _asyncIterator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncIterator";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator";
import { isAsyncIterable, isIterable } from "./_internal/utils.js";

function async(iterable) {
  var res, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

  return _regeneratorRuntime.async(function async$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          res = [];
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context.prev = 3;
          _iterator = _asyncIterator(iterable);

        case 5:
          _context.next = 7;
          return _regeneratorRuntime.awrap(_iterator.next());

        case 7:
          if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
            _context.next = 13;
            break;
          }

          item = _step.value;
          res.push(item);

        case 10:
          _iteratorAbruptCompletion = false;
          _context.next = 5;
          break;

        case 13:
          _context.next = 19;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](3);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 19:
          _context.prev = 19;
          _context.prev = 20;

          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context.next = 24;
            break;
          }

          _context.next = 24;
          return _regeneratorRuntime.awrap(_iterator.return());

        case 24:
          _context.prev = 24;

          if (!_didIteratorError) {
            _context.next = 27;
            break;
          }

          throw _iteratorError;

        case 27:
          return _context.finish(24);

        case 28:
          return _context.finish(19);

        case 29:
          return _context.abrupt("return", res);

        case 30:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[3, 15, 19, 29], [20,, 24, 28]], Promise);
}

function toArray(iter) {
  if (isAsyncIterable(iter)) {
    return async(iter);
  } else if (isIterable(iter)) {
    return Array.from(iter);
  } else {
    return [];
  }
}

export default toArray;